import { EditablePageClient } from '@/client';
import { ComponentHelperService, RefService } from '@/server/services';
import { MagnoliaConfig } from '@/server/types';
import {
  ContentRendererService,
  IMagnoliaContext,
  MgnlContent,
  MgnlTemplateAnnotations,
  PersonalizationService,
} from '@magnolia/frontend-helpers-base';

export const EditablePage = ({
  content,
  templateAnnotations,
  magnoliaContext,
  config = { componentMappings: {}, fallbackComponent: false },
  children,
}: {
  content: MgnlContent;
  templateAnnotations?: MgnlTemplateAnnotations;
  magnoliaContext?: IMagnoliaContext;
  config: MagnoliaConfig;
  children?: React.ReactElement | React.ReactElement[] | null;
}) => {
  if (!content) {
    return <div>No content to render</div>;
  }
  const selectedComponentVariants = JSON.parse(
    magnoliaContext?.searchParams?.['selectedComponentVariants'] || '{}'
  );
  const {
    content: renderingContent,
    templateAnnotations: templateAnnotationsWithVariants,
  } = PersonalizationService.getRenderContent(
    content,
    templateAnnotations,
    selectedComponentVariants
  );

  RefService.setConfigRef(config);
  if (templateAnnotationsWithVariants) {
    RefService.setTemplateAnnotationsRef(templateAnnotationsWithVariants);
  }
  if (renderingContent) {
    RefService.setContentRef(renderingContent);
  }
  const getPageComponent = () => {
    if (children) {
      return children;
    }

    return ComponentHelperService.getRenderedComponent(
      renderingContent,
      config.componentMappings,
      config.fallbackComponent
    );
  };

  return (
    content && (
      <>
        <EditablePageClient
          content={content}
          templateAnnotations={templateAnnotationsWithVariants}
          useHistoryPushState={config.useHistoryPushState}
          magnoliaContext={magnoliaContext}
        />
        <div key={ContentRendererService.buildKey(content)}>
          {getPageComponent()}
        </div>
      </>
    )
  );
};
